module.exports = __webpack_public_path__ + "img/winter-holiday.9c7977db.webp";